import React from 'react'
import { ServicesManagementContainer } from '@/features/services/components'

export default function ServicesManagementPage() {
  return <ServicesManagementContainer />
}
